export default "__VITE_ASSET__D8YMIyJq__"